import React from 'react';

export const DarkHeaderIllustration: React.FC = () => {
  return (
    <svg
      width="224"
      height="181"
      viewBox="0 0 224 181"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4125 102.657L16.5403 105.222L9.08693 119.971L19.6081 133.969L25.8317 136.156L25.294 139.413L17.1662 140.44L8.92385 135.067L3.19386 125.921L2.19771 120.53L1.96851 112.266L4.70128 106.465L9.26323 102.688L13.2037 102.031L16.4125 102.657Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.67349"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.4991 103.583C15.4869 103.49 17.5365 104.081 19.2687 105.103C21.812 106.602 23.7602 108.925 25.413 111.371C27.3128 114.179 28.8951 117.229 29.7943 120.495C30.6935 123.761 30.8918 127.261 30.0588 130.545C29.4373 132.991 28.2119 135.349 26.2637 136.958C19.7404 142.353 11.2732 135.221 7.93218 129.5C5.43742 125.224 4.40602 120.164 4.69252 115.223C4.82035 113.011 5.21703 110.78 6.18672 108.788C7.15641 106.796 8.74318 105.046 10.7839 104.182C11.6522 103.816 12.5691 103.627 13.4991 103.583Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.67349"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26.0565 138.108C32.8135 131.378 32.4477 121.434 28.7408 113.447L33.8317 111.556C37.5341 121.65 37.9397 130.985 32.2714 136.416C26.5105 141.934 17.1354 141.881 17.1354 141.881"
        fill="#8458FC"
      />
      <path
        d="M26.0565 138.108C32.8135 131.378 32.4477 121.434 28.7408 113.447L33.8317 111.556C37.5341 121.65 37.9397 130.985 32.2714 136.416C26.5105 141.934 17.1354 141.881 17.1354 141.881"
        stroke="white"
        stroke-width="0.67349"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.65955 101.233C9.45293 100.801 14.5658 99.2544 17.162 99.3161C24.4258 99.4924 30.8699 105.288 33.8539 111.6L28.8335 113.579C26.9603 109.586 23.9057 105.919 20.1636 103.565C19.2688 103.001 16.4788 101.357 15.6105 101.26"
        fill="#8458FC"
      />
      <path
        d="M8.65955 101.233C9.45293 100.801 14.5658 99.2544 17.162 99.3161C24.4258 99.4924 30.8699 105.288 33.8539 111.6L28.8335 113.579C26.9603 109.586 23.9057 105.919 20.1636 103.565C19.2688 103.001 16.4788 101.357 15.6105 101.26"
        stroke="white"
        stroke-width="0.67349"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9872 100.603C13.4638 100.546 14.9668 100.762 16.3729 101.211C19.4847 102.208 22.1778 104.244 24.4081 106.633C28.8995 111.437 31.6896 117.771 32.3507 124.317C32.7033 127.799 32.4389 131.444 30.8565 134.569C28.5998 139.021 23.6764 141.908 18.6869 141.952C9.25885 142.031 3.22031 133.224 1.18837 124.934C0.108484 120.513 0.0379615 115.836 1.07818 111.402C1.93767 107.735 3.69634 104.037 6.91395 102.071C8.43901 101.137 10.1977 100.669 11.9916 100.603H11.9872ZM12.7145 103.512C11.6698 103.548 10.6473 103.768 9.70402 104.222C8.03792 105.024 6.7685 106.487 5.8473 108.087C4.12389 111.085 3.5024 114.62 3.54207 118.075C3.59496 122.602 4.75418 127.155 7.16519 130.994C9.24121 134.296 12.2605 137.042 15.8395 138.628C19.5287 140.264 23.8571 139.047 26.6075 136.178C28.8951 133.789 30.0587 130.465 30.2306 127.164C30.4025 123.863 29.6444 120.566 28.494 117.463C27.4317 114.593 26.0125 111.83 24.0599 109.476C22.1073 107.122 19.5949 105.183 16.7078 104.169C15.434 103.719 14.0544 103.464 12.7101 103.512H12.7145Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.67349"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.8826 123.452C16.4391 124.484 18.9911 125.511 21.5476 126.542C21.6313 125.643 21.7195 124.74 21.8032 123.84C18.9514 122.778 16.0997 121.716 13.2479 120.654C13.1686 120.142 13.0936 119.631 13.0143 119.12C15.7735 120.23 18.5327 121.337 21.2963 122.448C21.4947 121.654 21.693 120.861 21.8914 120.067C19.0528 118.961 16.2143 117.859 13.3757 116.753C13.6181 115.708 14.5305 114.902 15.5619 114.606C16.5933 114.311 17.7085 114.465 18.709 114.835C19.7096 115.206 20.6219 115.792 21.5255 116.369C21.8561 115.294 22.1867 114.223 22.5173 113.147C20.5206 111.847 18.1051 111.058 15.7426 111.397C13.3801 111.737 11.7052 112.424 10.4799 115.646C9.70852 115.351 8.93717 115.051 8.16583 114.756C7.91459 115.541 7.65894 116.325 7.4077 117.114C8.28043 117.427 9.14874 117.736 10.0215 118.049C10.0215 118.529 10.0215 119.014 10.0215 119.494C9.07381 119.142 8.12615 118.789 7.1785 118.441C6.97134 119.129 6.75977 119.816 6.55261 120.504C7.81321 121.006 9.0738 121.504 10.3344 122.007C10.4843 125.185 11.93 128.279 14.2705 130.434C15.8352 131.876 17.7922 132.876 19.8638 133.348C20.3883 133.467 20.9173 133.551 21.455 133.603C21.7547 133.63 22.698 133.824 22.936 133.603C23.174 133.383 22.936 132.18 22.9272 131.862L22.8478 129.936C20.8467 130.104 18.7972 129.531 17.1707 128.358C15.5443 127.186 14.3586 125.414 13.8914 123.466L13.8826 123.452Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.67349"
        stroke-miterlimit="10"
      />
      <path
        d="M95.1222 97.4743L95.3065 102.838L79.2417 133.429L100.781 163.042L113.722 167.826L112.487 174.619L95.4632 176.49L78.403 164.996L66.7254 145.687L64.8175 134.378L64.6147 117.088L70.5135 105.05L80.1726 97.3084L88.4401 96.0641L95.1222 97.4743Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.879473"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M89.0114 99.3173C93.1773 99.1975 97.4355 100.488 101.021 102.681C106.284 105.898 110.293 110.82 113.666 115.99C117.546 121.926 120.754 128.35 122.523 135.217C124.293 142.083 124.597 149.401 122.745 156.24C121.371 161.337 118.726 166.222 114.597 169.521C100.781 180.591 83.3154 165.401 76.5134 153.327C71.435 144.304 69.4442 133.696 70.2092 123.364C70.5502 118.746 71.4534 114.092 73.5456 109.963C75.6378 105.834 79.0112 102.221 83.3062 100.488C85.1311 99.7505 87.0574 99.3818 89.0021 99.3265L89.0114 99.3173Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.879473"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M114.127 171.918C128.478 158.065 128.045 137.263 120.551 120.442L131.252 116.654C138.662 137.88 139.206 157.411 127.178 168.572C115.15 179.734 95.3528 179.503 95.3528 179.503"
        fill="#8458FC"
      />
      <path
        d="M114.127 171.918C128.478 158.065 128.045 137.263 120.551 120.442L131.252 116.654C138.662 137.88 139.206 157.411 127.178 168.572C115.15 179.734 95.3528 179.503 95.3528 179.503"
        stroke="white"
        stroke-width="0.879473"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M78.9563 94.239C80.6245 93.3634 91.3713 90.2942 96.7999 90.5154C111.98 91.1237 125.261 103.456 131.289 116.746L120.727 120.719C116.948 112.313 110.68 104.543 102.929 99.5017C101.077 98.2943 95.2976 94.7643 93.4819 94.5339"
        fill="#8458FC"
      />
      <path
        d="M78.9563 94.239C80.6245 93.3634 91.3713 90.2942 96.7999 90.5154C111.98 91.1237 125.261 103.456 131.289 116.746L120.727 120.719C116.948 112.313 110.68 104.543 102.929 99.5017C101.077 98.2943 95.2976 94.7643 93.4819 94.5339"
        stroke="white"
        stroke-width="0.879473"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M85.9334 93.0317C89.0302 92.9672 92.1547 93.4649 95.0856 94.4511C101.556 96.6354 107.123 100.986 111.713 106.046C120.948 116.24 126.57 129.576 127.741 143.281C128.358 150.572 127.695 158.185 124.275 164.664C119.409 173.89 109.021 179.78 98.588 179.706C78.8733 179.568 66.5321 160.95 62.5689 143.558C60.4491 134.277 60.4583 124.498 62.7809 115.263C64.7072 107.622 68.5045 99.9535 75.288 95.9442C78.5139 94.0455 82.2006 93.1239 85.9518 93.0409L85.9334 93.0317ZM87.362 99.1424C85.1776 99.1885 83.0301 99.6125 81.0393 100.534C77.5277 102.156 74.8272 105.17 72.8456 108.488C69.1405 114.7 67.7303 122.064 67.7026 129.3C67.6566 138.765 69.9423 148.332 74.8548 156.425C79.0853 163.402 85.3159 169.236 92.7446 172.664C100.404 176.204 109.491 173.798 115.335 167.89C120.201 162.968 122.745 156.065 123.206 149.162C123.667 142.258 122.201 135.346 119.897 128.82C117.768 122.793 114.902 116.968 110.892 111.981C106.883 106.995 101.694 102.857 95.6939 100.645C93.0395 99.6678 90.1731 99.0871 87.362 99.1424Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.879473"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M88.7537 113.843L94.551 132.507L101.454 119.88L109.897 124.599L100.597 139.383L110.349 143.005V149.06L100.376 145.373V147.926L110.118 151.807L109.897 158.618L100.376 154.36V164.295L90.6523 159.199L90.9196 151.217L80.9747 146.876V140.286L90.9012 144.977V142.037L80.9747 136.728V130.516L87.8412 133.677L78.5968 109.161L88.7537 113.843Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.879473"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M47.3388 6.03136L47.7344 10.3536L63.7468 33.3084L49.4364 59.2941L39.5229 64.4449L41.2026 69.7749L55.0725 69.5584L67.6137 58.5849L75.0414 41.8857L75.4295 32.6142L73.847 18.6994L67.875 9.62202L59.335 4.37413L52.5643 4.2099L47.3388 6.03136Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.797899"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M52.4375 6.88996C49.0783 7.21096 45.7862 8.68903 43.1287 10.8091C39.2245 13.9294 36.5072 18.289 34.32 22.7829C31.8043 27.9412 29.8783 33.4355 29.1467 39.1313C28.4152 44.827 28.9228 50.7393 31.0951 56.0469C32.715 60.0034 35.3352 63.6612 38.9856 65.8932C51.2058 73.3881 63.7096 59.4136 67.9497 49.0224C71.1149 41.2588 71.6374 32.5247 69.9802 24.3058C69.2337 20.6256 68.0393 16.9826 65.9417 13.8697C63.844 10.7568 60.7684 8.20381 57.133 7.24829C55.5952 6.84518 54.0126 6.74066 52.4375 6.88996Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.797899"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M39.605 67.7742C26.6757 58.0996 24.9139 41.3332 29.2287 27.0601L20.2409 25.1043C16.4337 42.9083 17.979 58.6594 28.7808 66.4155C39.7618 74.2986 55.4607 71.9695 55.4607 71.9695"
        fill="#8458FC"
      />
      <path
        d="M39.605 67.7742C26.6757 58.0996 24.9139 41.3332 29.2287 27.0601L20.2409 25.1043C16.4337 42.9083 17.979 58.6594 28.7808 66.4155C39.7618 74.2986 55.4607 71.9695 55.4607 71.9695"
        stroke="white"
        stroke-width="0.797899"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M59.9994 1.79135C58.5661 1.26134 49.6231 -0.119682 45.2859 0.604422C33.1478 2.6349 23.727 13.8846 20.226 25.1792L29.1168 27.2992C31.304 20.1552 35.5516 13.28 41.2698 8.44266C42.6358 7.28559 46.9207 3.85915 48.354 3.49337"
        fill="#8458FC"
      />
      <path
        d="M59.9994 1.79135C58.5661 1.26134 49.6231 -0.119682 45.2859 0.604422C33.1478 2.6349 23.727 13.8846 20.226 25.1792L29.1168 27.2992C31.304 20.1552 35.5516 13.28 41.2698 8.44266C42.6358 7.28559 46.9207 3.85915 48.354 3.49337"
        stroke="white"
        stroke-width="0.797899"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M63.1346 2.7765C68.9946 5.30713 72.8242 11.0925 75.1383 17.0346C77.9451 24.2234 78.938 32.0766 78.1766 39.7506C76.7507 54.1356 68.7259 70.3421 52.8926 72.4547C44.5169 73.5744 35.5739 69.8942 30.7216 62.9742C27.3251 58.1144 26.0112 52.0678 25.7723 46.1406C25.317 35.0103 28.4896 23.7232 34.8796 14.5936C38.0522 10.0623 42.0833 6.00137 47.0625 3.59018C49.3169 2.50029 51.7804 1.78366 54.2662 1.52239C57.2821 1.20886 60.3502 1.57464 63.1271 2.7765H63.1346ZM47.1968 8.62905C42.5984 11.0178 38.8435 14.8623 36.1337 19.2741C33.424 23.6859 31.707 28.6576 30.6022 33.7189C29.4152 39.1982 28.93 44.9014 30.005 50.4031C31.0799 55.9048 33.8271 61.1975 38.2314 64.6538C43.5241 68.8118 51.0712 69.8196 56.8715 66.199C62.6718 62.5785 66.9044 57.368 69.5993 51.3362C72.7271 44.3341 73.5856 36.4212 72.5927 28.8144C71.8313 23.0066 69.9501 17.2287 66.352 12.6153C64.426 10.1519 61.9477 8.00198 58.9617 7.05392C57.2746 6.51644 55.4979 6.38955 53.7436 6.57618C51.4743 6.81506 49.2273 7.57648 47.1968 8.62905Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.797899"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M49.093 57.1144L49.0034 53.2475C47.0252 53.7701 44.8827 53.6282 42.9941 52.8668C42.5611 52.6876 42.0908 52.4338 41.949 51.9859C41.8594 51.6948 41.9191 51.3813 41.9863 51.0827C42.27 49.7688 42.5611 48.4475 42.8448 47.1337C45.5247 47.7757 48.4361 47.3726 50.8473 46.0363C51.6908 45.566 52.5344 44.8942 52.6986 43.9387C52.9375 42.5128 51.5191 41.3334 50.1306 40.9452C48.7421 40.557 47.2193 40.5943 45.9428 39.9225C44.4274 39.1312 43.5316 37.4516 43.33 35.757C43.1285 34.0625 43.5465 32.353 44.1288 30.748C45.047 28.2025 46.5176 25.6644 48.9362 24.455C49.3841 24.2311 49.8918 24.0295 50.1456 23.5966C50.3471 23.2457 50.3471 22.8277 50.3396 22.4246C50.3173 21.3123 50.2949 20.2 50.265 19.0877C50.265 18.8041 50.265 18.5054 50.4218 18.274C50.6084 18.0202 50.9443 17.9306 51.2504 17.856C52.5493 17.5574 53.8482 17.2588 55.1471 16.9602C55.274 18.6772 55.4084 20.4016 55.5353 22.1185C56.7371 21.7229 58.0211 21.6034 59.2752 21.7751L58.8124 27.6127C55.8339 27.5008 52.4 27.8516 50.6756 30.2777C49.9589 31.2855 49.6827 32.7711 50.4591 33.734C51.1459 34.585 52.3477 34.7418 53.4078 35.0105C54.9903 35.4062 56.5132 36.2199 57.4762 37.5337C58.4392 38.8475 58.7602 40.557 58.6183 42.1769C58.4765 43.7968 57.8942 45.357 57.2 46.8276C56.237 48.8655 54.7962 50.9782 52.5866 51.4186C52.3029 51.4932 52.7956 55.054 52.6015 55.4497C52.1611 56.338 50.0784 56.7635 49.1154 57.1442V57.1293L49.093 57.1144Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.797899"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M125.133 22.9946L125.293 26.1979L115.986 44.6142L129.124 62.0948L136.895 64.8303L136.224 68.8922L126.075 70.1746L115.788 63.4653L108.633 52.0501L107.383 45.3132L107.097 34.9933L110.515 27.7501L116.206 23.0332L121.127 22.2131L125.133 22.9946Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.953872"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M121.501 24.1505C123.983 24.0349 126.542 24.7724 128.706 26.0493C131.881 27.9207 134.314 30.8213 136.378 33.876C138.75 37.382 140.726 41.1907 141.849 45.2692C142.972 49.3476 143.219 53.7178 142.179 57.8182C141.403 60.8729 139.873 63.8176 137.44 65.8265C129.294 72.5634 118.721 63.6579 114.549 56.5138C111.434 51.1749 110.146 44.8564 110.504 38.6864C110.664 35.9234 111.159 33.1384 112.37 30.6506C113.581 28.1628 115.562 25.9778 118.11 24.899C119.195 24.4422 120.339 24.2055 121.501 24.1505Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.953872"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M137.182 67.2687C145.619 58.8641 145.162 46.4472 140.534 36.474L146.891 34.1128C151.514 46.7169 152.02 58.3743 144.942 65.1552C137.749 72.0461 126.042 71.9801 126.042 71.9801"
        fill="#8458FC"
      />
      <path
        d="M137.182 67.2687C145.619 58.8641 145.162 46.4472 140.534 36.474L146.891 34.1128C151.514 46.7169 152.02 58.3743 144.942 65.1552C137.749 72.0461 126.042 71.9801 126.042 71.9801"
        stroke="white"
        stroke-width="0.953872"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M115.452 21.217C116.442 20.6776 122.827 18.7457 126.069 18.8227C135.139 19.0429 143.186 26.2806 146.912 34.1623L140.643 36.6336C138.304 31.647 134.49 27.0677 129.817 24.1286C128.7 23.4241 125.216 21.3711 124.132 21.25"
        fill="#8458FC"
      />
      <path
        d="M115.452 21.217C116.442 20.6776 122.827 18.7457 126.069 18.8227C135.139 19.0429 143.186 26.2806 146.912 34.1623L140.643 36.6336C138.304 31.647 134.49 27.0677 129.817 24.1286C128.7 23.4241 125.216 21.3711 124.132 21.25"
        stroke="white"
        stroke-width="0.953872"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M119.607 20.4297C121.451 20.3582 123.328 20.6278 125.084 21.1892C128.97 22.4331 132.333 24.976 135.118 27.9591C140.726 33.9585 144.21 41.8677 145.036 50.041C145.476 54.3892 145.146 58.941 143.17 62.8433C140.352 68.4023 134.204 72.0074 127.973 72.0624C116.2 72.1615 108.66 61.1646 106.123 50.8116C104.774 45.2911 104.686 39.4514 105.985 33.9144C107.058 29.3351 109.254 24.7173 113.272 22.2625C115.177 21.0957 117.373 20.5123 119.613 20.4297H119.607ZM120.516 24.0623C119.211 24.1063 117.934 24.3815 116.756 24.9485C114.676 25.9502 113.091 27.7775 111.94 29.7754C109.788 33.5181 109.012 37.9323 109.062 42.2474C109.128 47.9 110.575 53.5856 113.586 58.3795C116.178 62.502 119.949 65.931 124.418 67.9124C129.025 69.9544 134.43 68.4353 137.864 64.8522C140.721 61.8691 142.174 57.7191 142.388 53.5966C142.603 49.4686 141.656 45.3572 140.22 41.4824C138.893 37.8993 137.121 34.4483 134.683 31.5092C132.245 28.5701 129.107 26.1483 125.502 24.8824C123.912 24.321 122.189 24.0018 120.51 24.0623H120.516Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.953872"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M134.501 37.7343L133.246 41.3229C133.246 41.3229 127.032 37.6847 125.414 39.9359C123.273 42.9135 126.57 43.8822 127.908 44.4271C129.245 44.972 132.118 45.9517 132.118 45.9517L131.056 48.8743L125.97 47.0415L124.291 52.5454L133.621 56.1946L132.443 60.24L116.305 53.5692L117.467 50.2063C117.467 50.2063 123.081 49.6724 120.444 44.4711L116.69 43.1061L117.389 39.9744L120.081 40.8936C120.081 40.8936 119.756 33.3476 126.119 33.865C132.481 34.3823 134.501 37.7398 134.501 37.7398V37.7343Z"
        fill="#8458FC"
        stroke="white"
        stroke-width="0.953872"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <g filter="url(#filter0_d_3066_451957)">
        <path
          d="M142.18 47.2554C143.637 47.2554 145.078 47.486 146.478 47.9293L198.422 64.4615C203.782 66.1689 207.495 70.6916 208.113 76.2652C208.73 81.8387 206.104 87.0593 201.246 89.8912L195.936 92.9937L198.167 95.2183C200.711 97.7466 202.111 101.121 202.111 104.7C202.111 108.278 200.711 111.652 198.167 114.188L193.556 118.786C191.02 121.322 187.636 122.717 184.038 122.717C180.441 122.717 177.048 121.313 174.504 118.76L172.364 116.627L169.959 120.575C167.391 124.794 162.911 127.314 157.963 127.314H157.955C151.698 127.314 146.281 123.308 144.486 117.333L128.751 65.2906C127.459 60.9976 128.249 56.4906 130.925 52.9117C133.568 49.3739 137.775 47.2555 142.18 47.2554Z"
          fill="#8458FC"
        />
        <path
          d="M198.311 79.8079L179.283 90.9068L192.533 104.101C193.722 105.284 193.722 107.189 192.533 108.363L187.445 113.43C186.257 114.613 184.335 114.613 183.165 113.43L170.159 100.489L159.711 117.611C158.051 120.329 153.943 119.806 153.027 116.762L135.704 59.4975C134.851 56.6799 137.527 54.07 140.338 54.964L197.567 73.1522C200.614 74.1185 201.059 78.2185 198.311 79.8169V79.8079Z"
          fill="#8458FC"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3066_451957"
          x="95.2297"
          y="17.9522"
          width="136"
          height="136"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3066_451957"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3066_451957"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const LightHeaderIllustration: React.FC = () => {
  return (
    <svg
      width="224"
      height="181"
      viewBox="0 0 224 181"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4125 102.657L16.5403 105.222L9.08693 119.971L19.6081 133.969L25.8317 136.156L25.294 139.413L17.1662 140.44L8.92385 135.067L3.19386 125.921L2.19771 120.53L1.96851 112.266L4.70128 106.465L9.26323 102.688L13.2037 102.031L16.4125 102.657Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.67349"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.4991 103.583C15.4869 103.49 17.5365 104.081 19.2687 105.103C21.812 106.602 23.7602 108.925 25.413 111.371C27.3128 114.179 28.8951 117.229 29.7943 120.495C30.6935 123.761 30.8918 127.261 30.0588 130.545C29.4373 132.991 28.2119 135.349 26.2637 136.958C19.7404 142.353 11.2732 135.221 7.93218 129.5C5.43742 125.224 4.40602 120.164 4.69252 115.223C4.82035 113.011 5.21703 110.78 6.18672 108.788C7.15641 106.796 8.74318 105.046 10.7839 104.182C11.6522 103.816 12.5691 103.627 13.4991 103.583Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.67349"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26.0565 138.108C32.8135 131.378 32.4477 121.434 28.7408 113.447L33.8317 111.556C37.5341 121.65 37.9397 130.985 32.2714 136.416C26.5105 141.934 17.1354 141.881 17.1354 141.881"
        fill="#DDFD6C"
      />
      <path
        d="M26.0565 138.108C32.8135 131.378 32.4477 121.434 28.7408 113.447L33.8317 111.556C37.5341 121.65 37.9397 130.985 32.2714 136.416C26.5105 141.934 17.1354 141.881 17.1354 141.881"
        stroke="#06060C"
        stroke-width="0.67349"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.65955 101.233C9.45293 100.801 14.5658 99.2543 17.162 99.316C24.4258 99.4923 30.8699 105.288 33.8539 111.6L28.8335 113.579C26.9603 109.586 23.9057 105.919 20.1636 103.565C19.2688 103.001 16.4788 101.357 15.6105 101.26"
        fill="#DDFD6C"
      />
      <path
        d="M8.65955 101.233C9.45293 100.801 14.5658 99.2543 17.162 99.316C24.4258 99.4923 30.8699 105.288 33.8539 111.6L28.8335 113.579C26.9603 109.586 23.9057 105.919 20.1636 103.565C19.2688 103.001 16.4788 101.357 15.6105 101.26"
        stroke="#06060C"
        stroke-width="0.67349"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9872 100.603C13.4638 100.546 14.9668 100.762 16.3729 101.211C19.4847 102.207 22.1778 104.244 24.4081 106.633C28.8995 111.437 31.6896 117.771 32.3507 124.316C32.7033 127.798 32.4389 131.444 30.8565 134.569C28.5998 139.02 23.6764 141.907 18.6869 141.952C9.25885 142.031 3.22031 133.224 1.18837 124.933C0.108484 120.513 0.0379615 115.836 1.07818 111.402C1.93767 107.735 3.69634 104.037 6.91395 102.071C8.43901 101.136 10.1977 100.669 11.9916 100.603H11.9872ZM12.7145 103.512C11.6698 103.547 10.6473 103.768 9.70402 104.222C8.03792 105.024 6.7685 106.487 5.8473 108.087C4.12389 111.085 3.5024 114.619 3.54207 118.075C3.59496 122.602 4.75418 127.155 7.16519 130.994C9.24121 134.295 12.2605 137.041 15.8395 138.628C19.5287 140.263 23.8571 139.047 26.6075 136.177C28.8951 133.789 30.0587 130.465 30.2306 127.164C30.4025 123.862 29.6444 120.565 28.494 117.462C27.4317 114.593 26.0125 111.829 24.0599 109.476C22.1073 107.122 19.5949 105.183 16.7078 104.169C15.434 103.719 14.0544 103.464 12.7101 103.512H12.7145Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.67349"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.8826 123.452C16.4391 124.484 18.9911 125.511 21.5476 126.542C21.6313 125.643 21.7195 124.739 21.8032 123.84C18.9514 122.778 16.0997 121.716 13.2479 120.654C13.1686 120.142 13.0936 119.631 13.0143 119.12C15.7735 120.23 18.5327 121.337 21.2963 122.447C21.4947 121.654 21.693 120.861 21.8914 120.067C19.0528 118.961 16.2143 117.859 13.3757 116.753C13.6181 115.708 14.5305 114.902 15.5619 114.606C16.5933 114.311 17.7085 114.465 18.709 114.835C19.7096 115.206 20.6219 115.792 21.5255 116.369C21.8561 115.294 22.1867 114.223 22.5173 113.147C20.5206 111.847 18.1051 111.058 15.7426 111.397C13.3801 111.737 11.7052 112.424 10.4799 115.646C9.70852 115.351 8.93717 115.051 8.16583 114.756C7.91459 115.541 7.65894 116.325 7.4077 117.114C8.28043 117.427 9.14874 117.736 10.0215 118.049C10.0215 118.529 10.0215 119.014 10.0215 119.494C9.07381 119.142 8.12615 118.789 7.1785 118.441C6.97134 119.128 6.75977 119.816 6.55261 120.504C7.81321 121.006 9.0738 121.504 10.3344 122.007C10.4843 125.185 11.93 128.279 14.2705 130.434C15.8352 131.876 17.7922 132.876 19.8638 133.348C20.3883 133.467 20.9173 133.55 21.455 133.603C21.7547 133.63 22.698 133.824 22.936 133.603C23.174 133.383 22.936 132.18 22.9272 131.862L22.8478 129.936C20.8467 130.104 18.7972 129.531 17.1707 128.358C15.5443 127.186 14.3586 125.414 13.8914 123.466L13.8826 123.452Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.67349"
        stroke-miterlimit="10"
      />
      <path
        d="M95.1222 97.4741L95.3065 102.838L79.2417 133.429L100.781 163.042L113.722 167.826L112.487 174.618L95.4632 176.489L78.403 164.996L66.7254 145.687L64.8175 134.378L64.6147 117.087L70.5135 105.05L80.1726 97.3082L88.4401 96.064L95.1222 97.4741Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.879473"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M89.0114 99.317C93.1773 99.1972 97.4355 100.488 101.021 102.681C106.284 105.898 110.293 110.82 113.666 115.99C117.546 121.926 120.754 128.35 122.523 135.216C124.293 142.083 124.597 149.401 122.745 156.24C121.371 161.337 118.726 166.221 114.597 169.521C100.781 180.59 83.3154 165.401 76.5134 153.327C71.435 144.304 69.4442 133.695 70.2092 123.364C70.5502 118.746 71.4534 114.091 73.5456 109.962C75.6378 105.833 79.0112 102.22 83.3062 100.488C85.1311 99.7502 87.0574 99.3815 89.0021 99.3262L89.0114 99.317Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.879473"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M114.127 171.917C128.478 158.065 128.045 137.262 120.551 120.442L131.252 116.654C138.662 137.88 139.206 157.41 127.178 168.572C115.15 179.733 95.3528 179.503 95.3528 179.503"
        fill="#DDFD6C"
      />
      <path
        d="M114.127 171.917C128.478 158.065 128.045 137.262 120.551 120.442L131.252 116.654C138.662 137.88 139.206 157.41 127.178 168.572C115.15 179.733 95.3528 179.503 95.3528 179.503"
        stroke="#06060C"
        stroke-width="0.879473"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M78.9563 94.2389C80.6245 93.3633 91.3713 90.2941 96.7999 90.5153C111.98 91.1236 125.261 103.456 131.289 116.746L120.727 120.719C116.948 112.313 110.68 104.543 102.929 99.5016C101.077 98.2942 95.2976 94.7642 93.4819 94.5338"
        fill="#DDFD6C"
      />
      <path
        d="M78.9563 94.2389C80.6245 93.3633 91.3713 90.2941 96.7999 90.5153C111.98 91.1236 125.261 103.456 131.289 116.746L120.727 120.719C116.948 112.313 110.68 104.543 102.929 99.5016C101.077 98.2942 95.2976 94.7642 93.4819 94.5338"
        stroke="#06060C"
        stroke-width="0.879473"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M85.9334 93.0314C89.0302 92.9669 92.1547 93.4646 95.0856 94.4508C101.556 96.6352 107.123 100.986 111.713 106.046C120.948 116.239 126.57 129.576 127.741 143.281C128.358 150.572 127.695 158.185 124.275 164.664C119.409 173.89 109.021 179.78 98.588 179.706C78.8733 179.568 66.5321 160.95 62.5689 143.558C60.4491 134.276 60.4583 124.497 62.7809 115.262C64.7072 107.622 68.5045 99.9532 75.288 95.9439C78.5139 94.0453 82.2006 93.1236 85.9518 93.0407L85.9334 93.0314ZM87.362 99.1422C85.1776 99.1882 83.0301 99.6122 81.0393 100.534C77.5277 102.156 74.8272 105.17 72.8456 108.488C69.1405 114.7 67.7303 122.064 67.7026 129.299C67.6566 138.765 69.9423 148.332 74.8548 156.424C79.0853 163.401 85.3159 169.236 92.7446 172.664C100.404 176.203 109.491 173.798 115.335 167.89C120.201 162.968 122.745 156.065 123.206 149.162C123.667 142.258 122.201 135.346 119.897 128.82C117.768 122.792 114.902 116.967 110.892 111.981C106.883 106.995 101.694 102.857 95.6939 100.644C93.0395 99.6675 90.1731 99.0869 87.362 99.1422Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.879473"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M88.7537 113.843L94.551 132.507L101.454 119.88L109.897 124.599L100.597 139.382L110.349 143.005V149.06L100.376 145.373V147.926L110.118 151.807L109.897 158.618L100.376 154.36V164.295L90.6523 159.198L90.9196 151.217L80.9747 146.876V140.286L90.9012 144.977V142.037L80.9747 136.728V130.516L87.8412 133.677L78.5968 109.161L88.7537 113.843Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.879473"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M47.3388 6.03142L47.7344 10.3537L63.7468 33.3085L49.4364 59.2941L39.5229 64.445L41.2026 69.775L55.0725 69.5585L67.6137 58.5849L75.0414 41.8858L75.4295 32.6143L73.847 18.6995L67.875 9.62208L59.335 4.37419L52.5643 4.20996L47.3388 6.03142Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.797899"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M52.4375 6.88996C49.0783 7.21096 45.7862 8.68903 43.1287 10.8091C39.2245 13.9294 36.5072 18.289 34.32 22.7829C31.8043 27.9412 29.8783 33.4355 29.1467 39.1313C28.4152 44.827 28.9228 50.7393 31.0951 56.0469C32.715 60.0034 35.3352 63.6612 38.9856 65.8932C51.2058 73.3881 63.7096 59.4136 67.9497 49.0224C71.1149 41.2588 71.6374 32.5247 69.9802 24.3058C69.2337 20.6256 68.0393 16.9826 65.9417 13.8697C63.844 10.7568 60.7684 8.20381 57.133 7.24829C55.5952 6.84518 54.0126 6.74066 52.4375 6.88996Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.797899"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M39.605 67.7741C26.6757 58.0995 24.9139 41.3331 29.2287 27.0601L20.2409 25.1042C16.4337 42.9082 17.979 58.6594 28.7808 66.4155C39.7618 74.2985 55.4607 71.9694 55.4607 71.9694"
        fill="#DDFD6C"
      />
      <path
        d="M39.605 67.7741C26.6757 58.0995 24.9139 41.3331 29.2287 27.0601L20.2409 25.1042C16.4337 42.9082 17.979 58.6594 28.7808 66.4155C39.7618 74.2985 55.4607 71.9694 55.4607 71.9694"
        stroke="#06060C"
        stroke-width="0.797899"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M59.9994 1.79135C58.5661 1.26134 49.6231 -0.119682 45.2859 0.604422C33.1478 2.6349 23.727 13.8846 20.226 25.1792L29.1168 27.2992C31.304 20.1552 35.5516 13.28 41.2698 8.44266C42.6358 7.28559 46.9207 3.85915 48.354 3.49337"
        fill="#DDFD6C"
      />
      <path
        d="M59.9994 1.79135C58.5661 1.26134 49.6231 -0.119682 45.2859 0.604422C33.1478 2.6349 23.727 13.8846 20.226 25.1792L29.1168 27.2992C31.304 20.1552 35.5516 13.28 41.2698 8.44266C42.6358 7.28559 46.9207 3.85915 48.354 3.49337"
        stroke="#06060C"
        stroke-width="0.797899"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M63.1346 2.77656C68.9946 5.30719 72.8242 11.0926 75.1383 17.0347C77.9451 24.2235 78.938 32.0766 78.1766 39.7506C76.7507 54.1357 68.7259 70.3422 52.8926 72.4548C44.5169 73.5745 35.5739 69.8943 30.7216 62.9742C27.3251 58.1145 26.0112 52.0679 25.7723 46.1407C25.317 35.0104 28.4896 23.7233 34.8796 14.5936C38.0522 10.0624 42.0833 6.00143 47.0625 3.59024C49.3169 2.50035 51.7804 1.78372 54.2662 1.52245C57.2821 1.20892 60.3502 1.5747 63.1271 2.77656H63.1346ZM47.1968 8.62911C42.5984 11.0179 38.8435 14.8624 36.1337 19.2742C33.424 23.686 31.707 28.6577 30.6022 33.7189C29.4152 39.1982 28.93 44.9015 30.005 50.4032C31.0799 55.9049 33.8271 61.1975 38.2314 64.6538C43.5241 68.8118 51.0712 69.8196 56.8715 66.1991C62.6718 62.5786 66.9044 57.368 69.5993 51.3363C72.7271 44.3341 73.5856 36.4213 72.5927 28.8144C71.8313 23.0067 69.9501 17.2288 66.352 12.6154C64.426 10.152 61.9477 8.00204 58.9617 7.05398C57.2746 6.51651 55.4979 6.38961 53.7436 6.57624C51.4743 6.81512 49.2273 7.57655 47.1968 8.62911Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.797899"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M49.093 57.1144L49.0034 53.2475C47.0252 53.7701 44.8827 53.6282 42.9941 52.8668C42.5611 52.6876 42.0908 52.4338 41.949 51.9859C41.8594 51.6948 41.9191 51.3813 41.9863 51.0827C42.27 49.7688 42.5611 48.4475 42.8448 47.1337C45.5247 47.7757 48.4361 47.3726 50.8473 46.0363C51.6908 45.566 52.5344 44.8942 52.6986 43.9387C52.9375 42.5128 51.5191 41.3334 50.1306 40.9452C48.7421 40.557 47.2193 40.5943 45.9428 39.9225C44.4274 39.1312 43.5316 37.4516 43.33 35.757C43.1285 34.0625 43.5465 32.353 44.1288 30.748C45.047 28.2025 46.5176 25.6644 48.9362 24.455C49.3841 24.2311 49.8918 24.0295 50.1456 23.5966C50.3471 23.2457 50.3471 22.8277 50.3396 22.4246C50.3173 21.3123 50.2949 20.2 50.265 19.0877C50.265 18.8041 50.265 18.5054 50.4218 18.274C50.6084 18.0202 50.9443 17.9306 51.2504 17.856C52.5493 17.5574 53.8482 17.2588 55.1471 16.9602C55.274 18.6772 55.4084 20.4016 55.5353 22.1185C56.7371 21.7229 58.0211 21.6034 59.2752 21.7751L58.8124 27.6127C55.8339 27.5008 52.4 27.8516 50.6756 30.2777C49.9589 31.2855 49.6827 32.7711 50.4591 33.734C51.1459 34.585 52.3477 34.7418 53.4078 35.0105C54.9903 35.4062 56.5132 36.2199 57.4762 37.5337C58.4392 38.8475 58.7602 40.557 58.6183 42.1769C58.4765 43.7968 57.8942 45.357 57.2 46.8276C56.237 48.8655 54.7962 50.9782 52.5866 51.4186C52.3029 51.4932 52.7956 55.054 52.6015 55.4497C52.1611 56.338 50.0784 56.7635 49.1154 57.1442V57.1293L49.093 57.1144Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.797899"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M125.133 22.9944L125.293 26.1978L115.986 44.614L129.124 62.0946L136.895 64.8301L136.224 68.892L126.075 70.1744L115.788 63.4651L108.633 52.0499L107.383 45.313L107.097 34.9931L110.515 27.7499L116.206 23.033L121.127 22.2129L125.133 22.9944Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.953872"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M121.501 24.1503C123.983 24.0347 126.542 24.7722 128.706 26.0491C131.881 27.9205 134.314 30.8211 136.378 33.8758C138.75 37.3818 140.726 41.1906 141.849 45.269C142.972 49.3474 143.219 53.7176 142.179 57.818C141.403 60.8727 139.873 63.8174 137.44 65.8263C129.294 72.5632 118.721 63.6578 114.549 56.5136C111.434 51.1748 110.146 44.8562 110.504 38.6863C110.664 35.9233 111.159 33.1382 112.37 30.6505C113.581 28.1627 115.562 25.9776 118.11 24.8988C119.195 24.442 120.339 24.2053 121.501 24.1503Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.953872"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M137.182 67.2684C145.619 58.8639 145.162 46.4469 140.534 36.4738L146.891 34.1125C151.514 46.7166 152.02 58.374 144.942 65.1549C137.749 72.0459 126.042 71.9798 126.042 71.9798"
        fill="#DDFD6C"
      />
      <path
        d="M137.182 67.2684C145.619 58.8639 145.162 46.4469 140.534 36.4738L146.891 34.1125C151.514 46.7166 152.02 58.374 144.942 65.1549C137.749 72.0459 126.042 71.9798 126.042 71.9798"
        stroke="#06060C"
        stroke-width="0.953872"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M115.452 21.2168C116.442 20.6774 122.827 18.7455 126.069 18.8226C135.139 19.0427 143.186 26.2804 146.912 34.1621L140.643 36.6334C138.304 31.6468 134.49 27.0675 129.817 24.1284C128.7 23.4239 125.216 21.3709 124.132 21.2498"
        fill="#DDFD6C"
      />
      <path
        d="M115.452 21.2168C116.442 20.6774 122.827 18.7455 126.069 18.8226C135.139 19.0427 143.186 26.2804 146.912 34.1621L140.643 36.6334C138.304 31.6468 134.49 27.0675 129.817 24.1284C128.7 23.4239 125.216 21.3709 124.132 21.2498"
        stroke="#06060C"
        stroke-width="0.953872"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M119.607 20.4295C121.451 20.358 123.328 20.6277 125.084 21.1891C128.97 22.433 132.333 24.9758 135.118 27.9589C140.726 33.9583 144.21 41.8675 145.036 50.0409C145.476 54.389 145.146 58.9408 143.17 62.8431C140.352 68.4021 134.204 72.0072 127.973 72.0622C116.2 72.1613 108.66 61.1644 106.123 50.8114C104.774 45.2909 104.686 39.4512 105.985 33.9142C107.058 29.3349 109.254 24.7171 113.272 22.2623C115.177 21.0955 117.373 20.5121 119.613 20.4295H119.607ZM120.516 24.0621C119.211 24.1062 117.934 24.3814 116.756 24.9483C114.676 25.95 113.091 27.7773 111.94 29.7752C109.788 33.5179 109.012 37.9321 109.062 42.2472C109.128 47.8998 110.575 53.5854 113.586 58.3794C116.178 62.5018 119.949 65.9308 124.418 67.9122C129.025 69.9542 134.43 68.4351 137.864 64.852C140.721 61.8689 142.174 57.7189 142.388 53.5964C142.603 49.4684 141.656 45.357 140.22 41.4822C138.893 37.8991 137.121 34.4481 134.683 31.509C132.245 28.5699 129.107 26.1481 125.502 24.8822C123.912 24.3208 122.189 24.0016 120.51 24.0621H120.516Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.953872"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M134.501 37.7341L133.246 41.3227C133.246 41.3227 127.032 37.6846 125.414 39.9357C123.273 42.9133 126.57 43.882 127.908 44.4269C129.245 44.9718 132.118 45.9515 132.118 45.9515L131.056 48.8741L125.97 47.0413L124.291 52.5453L133.621 56.1944L132.443 60.2398L116.305 53.569L117.467 50.2061C117.467 50.2061 123.081 49.6722 120.444 44.4709L116.69 43.106L117.389 39.9742L120.081 40.8934C120.081 40.8934 119.756 33.3474 126.119 33.8648C132.481 34.3822 134.501 37.7396 134.501 37.7396V37.7341Z"
        fill="#DDFD6C"
        stroke="#06060C"
        stroke-width="0.953872"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <g filter="url(#filter0_d_3066_456886)">
        <path
          d="M142.18 47.2554C143.637 47.2554 145.078 47.486 146.478 47.9292L198.422 64.4614C203.782 66.1688 207.495 70.6915 208.113 76.2651C208.73 81.8387 206.104 87.0592 201.246 89.8911L195.936 92.9937L198.167 95.2183C200.711 97.7465 202.111 101.121 202.111 104.7C202.111 108.278 200.711 111.652 198.167 114.188L193.556 118.786C191.02 121.322 187.636 122.717 184.038 122.717C180.441 122.717 177.048 121.313 174.504 118.76L172.364 116.626L169.959 120.575C167.391 124.794 162.911 127.314 157.963 127.314H157.955C151.698 127.314 146.281 123.308 144.486 117.333L128.751 65.2905C127.459 60.9975 128.249 56.4905 130.925 52.9116C133.568 49.3738 137.775 47.2554 142.18 47.2554Z"
          fill="#DDFD6C"
        />
        <path
          d="M198.311 79.8079L179.283 90.9068L192.533 104.101C193.722 105.284 193.722 107.189 192.533 108.363L187.445 113.43C186.257 114.613 184.335 114.613 183.165 113.43L170.159 100.489L159.711 117.611C158.051 120.329 153.943 119.806 153.027 116.762L135.704 59.4975C134.851 56.6799 137.527 54.07 140.338 54.964L197.567 73.1522C200.614 74.1185 201.059 78.2185 198.311 79.8169V79.8079Z"
          fill="#DDFD6C"
          stroke="#06060C"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3066_456886"
          x="95.2297"
          y="17.9521"
          width="136"
          height="136"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3066_456886"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3066_456886"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
